import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import { ReactElement, useCallback, useEffect, useRef } from 'react'

import { useGlobalFiscalYear } from '../../../../../../../../contexts/globalFiscalYearContext'
import { PeriodValue } from '../../../../../../../../types/periodValue'
import { getPeriodValueFromFiscalYear } from '../../../../../../../../utils/getPeriodValueFromFiscalYear'
import { useInvoicesList } from '../../../../context/invoicesList'
import { useInvoicesListFilters } from '../../../../context/invoicesListFilters'

export const InvoicesPeriodSelector = (): ReactElement => {
  const hasPeriodBeenSetRef = useRef(false)
  const { organization } = useInvoicesList()
  const [{ period: queryParamPeriod }, setFilters] = useInvoicesListFilters()
  const { fiscalYear: globalFiscalYear } = useGlobalFiscalYear()
  const organizationId = organization?.id

  useEffect(() => {
    if (!!organizationId && !queryParamPeriod && globalFiscalYear !== undefined && !hasPeriodBeenSetRef.current) {
      hasPeriodBeenSetRef.current = true
      setFilters({ period: encodePeriodValue(getPeriodValueFromFiscalYear(globalFiscalYear), organizationId) })
    }
  }, [globalFiscalYear, organizationId, queryParamPeriod, setFilters])

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organizationId) {
        return
      }

      setFilters({ period: encodePeriodValue(periodValue, organizationId) })
    },
    [organizationId, setFilters],
  )

  return <GlobalPeriodSelect encodedPeriod={queryParamPeriod} onChange={handlePeriodChange} placement="bottom-end" />
}
